module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "panel"
  }, [_c('h2', [_vm._v("My Journey")]), _vm._v(" "), _vm._l((_vm.studentTerms), function(term, index) {
    return _c('div', {
      key: term.id,
      staticClass: "term",
      style: ({
        '--height': term.height
      })
    }, [_c('div', {
      staticClass: "center-line"
    }), _vm._v(" "), _c('div', {
      staticClass: "term-name"
    }, [_vm._v("\n      Start of Your Think Tank Journey\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "events"
    }, _vm._l((term.events), function(event) {
      return _c('div', {
        key: event.id,
        staticClass: "event",
        class: {
          'you-are-here': event.name == 'you_are_here', glowing: _vm.openEvent == event.id || _vm.glowing == event.id
        },
        style: ({
          '--top': event.top,
          '--width': event.width,
          '--drop': event.drop,
          '--height': event.height,
          '--shift': event.shift,
          '--color': event.status.color,
          '--z-index': event.status.level,
          '--tcolor': event.status.tcolor
        })
      }, [_c('div', {
        staticClass: "title",
        on: {
          "click": function($event) {
            _vm.openEvent == event.id ? _vm.openEvent = -1 : _vm.openEvent = event.id
          },
          "mouseover": function($event) {
            _vm.glowing = event.id
          },
          "mouseleave": function($event) {
            _vm.glowing = -1
          }
        }
      }, [(event.name.includes('Term Start')) ? _c('strong', {
        staticClass: "capitalize"
      }, [_vm._v(_vm._s(event.name))]) : _c('span', [_vm._v(_vm._s(event.name) + " " + _vm._s(event.status.msg))]), _vm._v(" "), (_vm.openEvent == event.id && (event.description || event.media || event.link)) ? _c('div', {
        staticClass: "event-content"
      }, [_c('i', {
        staticClass: "fa fa-remove",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.openEvent = -1
          }
        }
      }), _vm._v(" "), (event.media) ? _c('div', {
        staticClass: "media"
      }, [(event.media.includes('.mp4')) ? _c('video', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.openVideo = event.media
          }
        }
      }, [_c('source', {
        attrs: {
          "src": event.media
        }
      })]) : _c('img', {
        attrs: {
          "src": event.media
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.openImage = event.media
          }
        }
      })]) : _vm._e(), _vm._v(" "), (event.description) ? _c('div', [_vm._v(_vm._s(event.description))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "bottom-row"
      }, [_vm._v("\n              Due: "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.$options.filters.journeyDate(event.end))
        }
      }), _vm._v(" "), (event.link) ? _c('a', {
        attrs: {
          "href": event.link,
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_vm._v("Read More")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "borders",
        class: {
          hasDuration: event.duration
        }
      }), _vm._v(" "), (!event.hideStart) ? _c('div', {
        staticClass: "startDate",
        domProps: {
          "innerHTML": _vm._s(_vm.$options.filters.journeyDate(event.start))
        }
      }) : _vm._e(), _vm._v(" "), (!event.hideEnd) ? _c('div', {
        staticClass: "endDate",
        domProps: {
          "innerHTML": _vm._s(_vm.$options.filters.journeyDate(event.end))
        }
      }) : _vm._e()])
    }))])
  }), _vm._v(" "), (_vm.openVideo || _vm.openImage) ? _c('div', {
    staticClass: "lightbox",
    on: {
      "click": function($event) {
        _vm.openVideo = null;
        _vm.openImage = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" "), (_vm.openVideo) ? _c('video', {
    attrs: {
      "controls": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.openVideo
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.openImage) ? _c('img', {
    attrs: {
      "src": _vm.openImage
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8e451cf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Journey.vue
// module id = 2073
// module chunks = 2